@import 'apps/webcomponents/src/assets/text-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';

:host {
  max-width: 220px;
}

gz-counter::part(counter) {
  font-size: 48px;
}

.gauge {
  overflow: hidden;

  &--wrapper {
    position: relative;
  }

  &--labels-container {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  &--value {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
    width: 100%;
    text-align: center;
    font-size: 48px;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--black-layout-700-primary);
    --font-family: var(--font-family-secondary-mono);

    .disabled {
      color: var(--main-titles-inputs-600);
      font-size: 70px;
      line-height: 32px;
      margin-left: -10px;
    }

    gz-counter {
      &::part(counter-value) {
        font-size: 48px;
        font-size: 3cqw;
        color: var(--black-layout-700-primary);
      }
      & > span {
        color: var(--black-layout-700-primary);
      }
    }
  }
}

.gauge-marker {
  transition: all 0.6s ease;
}

.gauge-progress {
  transition: all 0.6s ease;
  stroke-linecap: round;
}

.outer-wrapper {
  width: 220px;
}

.marker {
  position: absolute;
  z-index: 100;
  left: 0;
  top: 0;
  transform-origin: bottom center;
  transition: all 0.6s ease;
}

.outer {
  stroke: var(--chart-051-hover);
  stroke-dasharray: 0.5;
}

.step {
  position: absolute;
  width: 2px;
  height: 20px;
  background-color: var(--white-layout-302-level-1-elevation);

  &--1 {
    left: 18%;
    bottom: 58%;
    transform: rotate(-45deg);
  }

  &--2 {
    left: 50%;
    top: 5px;
  }

  &--3 {
    bottom: 55%;
    right: 16%;
    transform: rotate(45deg);
  }
}

:host(:not([animations])) {
  .marker,
  .gauge-progress,
  .gauge-marker {
    transition: none;
  }

  .gauge--wrapper {
    .marker {
      line {
        display: none;
      }
    }
  }
}

:host([hasLabels]) {
  .outer-wrapper {
    width: inherit;
  }

  .gauge--value {
    font-size: 36px;
    font-size: 3cqw;

    gz-counter::part(counter) {
      font-size: 36px;
      font-size: 3cqw;
    }
  }

  .step {
    display: none;
  }

  .gauge-progress {
    stroke-linecap: square;
  }
}
